<template>
    <v-snackbar v-model="show" :timeout="duration">
      <span class="ml-4" v-html="text"></span>
      <v-btn small outlined color="primary" @click="destroyVm">{{  btnText }}</v-btn>
  </v-snackbar>
</template>

<script>
export default {
    name:"Toast",
    data() {
      return {
        show: false,
        text: '',
        duration: 3000,
        btnText: 'Close'
      }
    },
    mounted() {
      this.show = true;
      setTimeout( () => this.destroyVm(), this.duration);
    },
    methods:{
      destroyVm() {
        if(this.show) {
          this.show = false;
          this.$destroy(true);
          this.$el.parentNode.removeChild(this.$el);
        }
      }
    }
}
</script>